// @flow

import React, { PureComponent } from 'react';
import { pick } from 'lodash';

import { getGGMapsLink } from 'utils/urlUtils';

import OpenStreetMap from 'components/fragments/map/OpenStreetMap';

type Props = {
  name?: string,
  street?: string,
  postal_code?: string,
  locality?: string,
  lat?: string,
  long?: string,
  complement_adress?: string,
  height?: string,
  width?: string,
  classname?: string,
};

export default class CardMap extends PureComponent<Props> {
  static defaultProps = {
    name: 'Plouzané AC',
    street: '42 Rue des Marguerites',
    postal_code: '29280',
    locality: 'Plouzané',
    lat: '0',
    long: '0',
    width: '425',
    height: '350',
  };

  render() {
    const {
      name,
      street,
      postal_code,
      locality,
      complement_adress,
      classname
    } = this.props;
    const mapProps = pick(this.props, ['width', 'height', 'long', 'lat']);
    const address = (
      street
      && postal_code
      && locality
      && `${street}+${postal_code}+${locality}`
        .split(' ')
        .join('+'))
      || ''; 
    let classNameFinal = 'address';
    if (classname) {
      classNameFinal += ' '+classname;
    }

    return (
      <div className={classNameFinal}>
        <a
          style={{ zIndex: '50' }}
          href={getGGMapsLink(null, address)}
          title={name}
          target="_blank"
          rel='noopener noreferrer'
          className="box box--white card card--address">
          <div className="card__body">
            {name && <h3 className="card__title ft-h3">{name}</h3>}
            <p className="card__desc">
              {complement_adress || ''} {street || ''}, {postal_code || ''} {locality || ''}
            </p>
          </div>
          <div className="card__footer">
            <span className="link-chevron ">
              Voir l&apos;itinéraire<i className="icon icon-chevron-right" />
            </span>
          </div>
        </a>
        <OpenStreetMap {...mapProps} />
      </div>
    );
  }
}
